import { choicesFromEnum } from '../../../@helpers/choices-from-enum';

export enum CreditAssetType {
  Credit = 'CREDIT',
  Collateral = 'COLLATERAL',
}

export const CreditAssetTypeChoices = choicesFromEnum(CreditAssetType)